module.exports = __webpack_public_path__ + "img/x-social-media-round-icon.1a2081e2.svg";